import { FETCH_PRICING_PLANS, CHANGE_PRICING_PLAN, SELECT_PRICING_PLAN } from "../actionTypeConstants/constants";

export const fetchPricingPlans = () => {
    const action = {
      type: FETCH_PRICING_PLANS
    };
    return action;
  };
export const changePricingPlan = (durationType) => {
    const action = {
      type: CHANGE_PRICING_PLAN,
      durationType: durationType
    };
    return action;
  };

export const selectPricingPlan = (item, index, mainindex) => {
    const action = {
      type: SELECT_PRICING_PLAN,
      item: item,
      index: index,
      mainindex: mainindex
    };
    return action;
  };